import type { UserManagerSettings } from "oidc-client-ts";

export interface OidcSettingsOptions {
  /** The identity server's origin (config `IDENTITY_URL`). */
  identityUrl: string;
  /** The app's OpenIddict client id, as its `Identity:Apps` registry block names it. */
  clientId: string;
  /** The scopes the app asks for. Default: the external apps' (profile, email, a refresh token, the Optimyl claims). */
  scope?: string;
}

/**
 * How an Optimyl app talks to the identity server: the authorization code flow with PKCE, the callback at
 * `/auth/callback` on the app's own origin, and a refresh token renewed in the background.
 */
export function createOidcSettings({ identityUrl, clientId, scope = "openid profile email offline_access optimyl:claims" }: OidcSettingsOptions): UserManagerSettings {
  return {
    authority: identityUrl,
    client_id: clientId,
    redirect_uri: `${window.location.origin}/auth/callback`,
    response_type: "code",
    scope,
    automaticSilentRenew: true,
  };
}
